import { isText } from "@/utils/types.ts";
import { CONFIGURATOR_CONSENT_MODE, SHOULD_TRACK_BY_DEFAULT } from "../resources/constants.ts";

export function userGaveConsent() {
    // OneTrust publishes active groups on window, not on the SDK object.
    if (!isText(window.OnetrustActiveGroups)) {
        return SHOULD_TRACK_BY_DEFAULT;
    }

    return window.OnetrustActiveGroups.includes(CONFIGURATOR_CONSENT_MODE);
}
